import { render, staticRenderFns } from "./portfolioD.vue?vue&type=template&id=77ce2e9d"
import script from "./portfolioD.vue?vue&type=script&lang=js"
export * from "./portfolioD.vue?vue&type=script&lang=js"
import style0 from "./portfolioD.vue?vue&type=style&index=0&id=77ce2e9d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports